import { Component, OnInit, Input, Output, EventEmitter } from '@angular/core';
import { TransformDetail } from '../../../api/models';
import { DataService, } from '../../../api/services';
import { DataAnalysisTransform } from '../../models/data-analysis';

@Component({
  selector: 'app-transform-editor',
  templateUrl: './transform-editor.component.html',
  styleUrls: ['./transform-editor.component.css']
})
export class TransformEditorComponent implements OnInit {
  @Input() public transforms: DataAnalysisTransform[];
  @Input() public showTitle: boolean = true;

  public transformList: TransformDetail[];  
  public transform: string;
  


  sortableOptions: any;
  
  constructor(private dataService: DataService) {
      
  }

  ngOnInit() {
    //console.log("Transforms", this.transforms);
    if (this.transformList == null){
      this.dataService.DataGetTransforms().subscribe(d => {
        this.transformList = d;
        //console.log('Transforms List:', this.transformList)
      });
    }
  } 

  public getTransformDetails(transform: any){
    //console.log(transform);
    //console.log(transform);
    if (this.transformList != null){
      return this.transformList.find(t => t.id == transform.transform.id);
    }
    return null;
  }

  public addTransform(transform: string){
    var transformDetail = this.transformList.find(t => t.id == transform);
    var config = [];
    if (transformDetail.parameters) {
      for (let ta of transformDetail.parameters){
        config.push({    
          name: ta.name,
          value: ta.defaultValue,
        });
      }
    }
    this.transforms.push({
      transform: transformDetail,
      config: config
    });
  }

  public removeTransform(transform: DataAnalysisTransform){
    var index = this.transforms.indexOf(transform);
    if (index > -1){
      this.transforms.splice(index, 1);
    }
  }

}
